class CelebritiesEndorsementV2 {
    constructor(element) {
        this.element = element;
        this.swiper = null;
        this.isInitialized = false;
        this.handleResize = this.handleResize.bind(this);
    }

    init() {
        this.initializeSwiper();
        // Listen for resize events to handle responsive behavior
        window.addEventListener('resize', this.handleResize);
    }

    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const isMobile = window.innerWidth <= 768;
        if (isMobile && !this.isInitialized) {
            this.initializeSwiper();
        } else if (!isMobile && this.isInitialized) {
            this.destroySwiper();
        }
    }

    initializeSwiper() {
        // Only initialize on mobile devices
        if (window.innerWidth > 768) return;

        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            setTimeout(() => this.initializeSwiper(), 100);
            return;
        }

        const slider = this.element.querySelector('.celebrities-endorsement__grid');
        if (!slider || this.isInitialized) return;

        // Add Swiper wrapper and slide classes
        slider.classList.add('swiper');
        
        // Create wrapper div
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');
        
        // Move all cards into the wrapper and add swiper-slide class
        const cards = slider.querySelectorAll('.celebrities-endorsement__card');
        cards.forEach(card => {
            card.classList.add('swiper-slide');
            wrapper.appendChild(card);
        });
        
        // Clear the slider and add the wrapper
        slider.innerHTML = '';
        slider.appendChild(wrapper);

        // Add pagination container if it doesn't exist
        let paginationContainer = this.element.querySelector('.celebrities-endorsement__pagination');
        if (!paginationContainer) {
            paginationContainer = document.createElement('div');
            paginationContainer.classList.add('celebrities-endorsement__pagination');
            slider.parentNode.appendChild(paginationContainer);
        }

        // Initialize Swiper
        this.swiper = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 16,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '.celebrities-endorsement__pagination',
                clickable: true,
                dynamicBullets: true,
            },
            breakpoints: {
                480: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
            pagination: {
                el: '.celebrities-endorsement__pagination',
                clickable: true,
                type: 'bullets',
            },
            speed: 300,
            grabCursor: true,
            watchOverflow: true,
        });

        this.isInitialized = true;
    }

    destroySwiper() {
        if (this.swiper) {
            // Get the cards before destroying
            const cards = this.element.querySelectorAll('.celebrities-endorsement__card');
            const slider = this.element.querySelector('.celebrities-endorsement__grid');
            
            // Destroy swiper
            this.swiper.destroy(true, true);
            this.swiper = null;
            
            // Remove swiper classes
            slider.classList.remove('swiper');
            
            // Remove wrapper and restore original structure
            slider.innerHTML = '';
            cards.forEach(card => {
                card.classList.remove('swiper-slide');
                slider.appendChild(card);
            });
            
            // Remove pagination
            const pagination = this.element.querySelector('.celebrities-endorsement__pagination');
            if (pagination) {
                pagination.remove();
            }
            
            this.isInitialized = false;
        }
    }
}

// Initialize all celebrities endorsement v2 sections on page load
document.addEventListener('DOMContentLoaded', function() {
    // Target sections that contain the celebrities endorsement v2 structure
    const sections = document.querySelectorAll('.celebrities-endorsement');
    sections.forEach(section => {
        // Check if this section is from the celebrities-endorsement-v2 template
        if (section.querySelector('.celebrities-endorsement__grid-container[x-data]')) {
            const instance = new CelebritiesEndorsementV2(section);
            instance.init();
        }
    });
}); 